import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const Address = observer(class Address extends React.Component {
  constructor() {
    super();
    this.geolocate = this.geolocate.bind(this);
  }

  geolocate(e) {
    // To prevent autofilling, the address field is readonly which needs to be changed
    e.target.removeAttribute('readOnly');

    const _this = this;
    const google = window.google;
    const input = document.querySelector('#address-autocomplete')
    const autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});
    autocomplete.addListener('place_changed', (e) => updateAddress(e));

    // Prevent submit on enter
    google.maps.event.addDomListener(input, 'keydown', function(e){
      if(e.keyCode === 13) {
        e.preventDefault();
      }
    });

    function updateAddress() {
      const place = autocomplete.getPlace();

      let location = {
        address1: null,
        address2: null,
        place: null,
        region: null,
        country: null,
        postalCode: null,
        lat: null,
        lng: null
      }

      if(!place.geometry) {
        // The user entered the name of a place that wasn’t suggested
        // and pressed the Enter key, or the request failed
        // window.alert(`No details available for “${place.name}”`);
        let suggestions = document.querySelector('.pac-container');
        setTimeout(function(){
          suggestions.style.display = 'block';
        });
        return;
      } else {
        // Loop through address components to get data
        for(let i = 0; i < place.address_components.length; i++) {
          // Address 1 number
          if(place.address_components[i].types.indexOf('street_number') > -1) {
            location.address1 = place.address_components[i].short_name;
          }

          // Address 1 street
          if(place.address_components[i].types.indexOf('route') > -1) {
            if(location.address1) {
              location.address1 += ' ' + place.address_components[i].short_name;
            } else {
              location.address1 = place.address_components[i].short_name;
            }
          }

          // Address 2
          if(place.address_components[i].types.indexOf('subpremise') > -1) {
            location.address2 = place.address_components[i].short_name;
          }

          // City
          if(place.address_components[i].types.indexOf('locality') > -1) {
            location.place = place.address_components[i].short_name;
          }

          // Region
          if(place.address_components[i].types.indexOf('administrative_area_level_1') > -1) {
            location.region = place.address_components[i].short_name;
          }

          // Country
          if(place.address_components[i].types.indexOf('country') > -1) {
            location.country = place.address_components[i].short_name;
          }

          // Postal code
          if(place.address_components[i].types.indexOf('postal_code') > -1) {
            location.postalCode = place.address_components[i].short_name;
          }

          // Lat/lng
          location.lat = place.geometry.location.lat();
          location.lng = place.geometry.location.lng();
        }

        // Check if address components contained a street address
        // and parse the formatted address if it didn’t
        if(!location.address1) {
          let addr_arr = place.formatted_address.split(',');

          if(addr_arr.length > 3) {
            location.address1 = addr_arr[0];

            if(addr_arr.length > 4) {
              location.address2 = addr_arr[1].replace(' ', '');
            }
          }
        }

        _this.props.parent.setState({
          location
        });

        if(_this.props.onSelect) {
          _this.props.onSelect();
        }
      }
    }
  }

  render() {
    const { translation } = this.props;

    return (
      <div>
        <label className="meta" htmlFor="autocomplete">
          {translation.label}
        </label>

        <input
          id="address-autocomplete"
          type="text"
          onFocus={(e) => this.geolocate(e)}
          placeholder={translation.label}
          required
          aria-required="true"
          autoComplete="false"
          readOnly
        />
      </div>
    );
  }
})

export default translate('Address')(Address);



// WEBPACK FOOTER //
// ./src/app/components/Map/Address.js